import { denormalize } from 'normalizr';
import get from 'lodash/get';
import { getStore as getDB } from '../../../common/state/db/DB.store';
import schema from './Product.schema';
import vendorSchema from './Vendor.schema';

export const DOMAIN = `db.${schema.key}`;

export const getStore = state => get(state, DOMAIN) || {};

export const getEntityById = (state, id) => denormalize(id, schema, getDB(state)) || {};
export const getEntitiesForIds = (state, ids) => denormalize(ids, [schema], getDB(state));

export const getEntityFieldById = (state, { id, field }) =>
    get(getStore(state), [id, field]) || null;

export const getVendorForId = (state, id) =>
    denormalize(getEntityFieldById(state, { id, field: 'vendor' }), [vendorSchema], getDB(state));
export const getVendorsForIds = (state, ids) =>
    denormalize(
        ids
            .map(id => getEntityFieldById(state, { id, field: 'vendor' }))
            .filter(id => !!id)
            .filter((id, index, self) => self.indexOf(id) === index),
        [vendorSchema],
        getDB(state)
    );
